import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../data/comparison';
import { Eyebrow } from './Eyebrow';
export function Comparison() {
  return <section aria-labelledby="comparison-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-60" data-mp="1l7dzr0s835gm">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-61" data-mp="1py472jk7lidy">
        <div className="max-w-3xl" data-id="element-62" data-mp="1pzp2ebecl5cv">
          <Eyebrow tone="rose" data-id="element-63" data-mp="1pzyqtujqv4gg">Przed i po</Eyebrow>
          <h2 id="comparison-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-64" data-mp="1uwfhavef1uwp">
            Przestań improwizować. <span className="text-amber" data-id="element-65" data-mp="23xdpzqzsuqlm">Zacznij uczyć z systemem.</span>
          </h2>
        </div>
        <div className="mt-10 grid gap-5 lg:mt-12 lg:grid-cols-2 lg:gap-6" data-id="element-66" data-mp="28xi4xcl27d9q">
          <div className="rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-8" data-id="element-67" data-mp="9jvyjsw9x9lb">
            <p className="text-[11px] font-semibold uppercase tracking-label text-rose" data-id="element-68" data-mp="9m8pgvk0euai">Bez Arsenału</p>
            <ul className="mt-5 divide-y divide-night-600" data-id="element-69" data-mp="1m0pbq9x1pdeh">
              {comparisonRows.map(row => <li key={row.without} className="flex items-start gap-3 py-4 first:pt-0 last:pb-0" data-id="element-70" data-mp="1ha0iap1t26cp">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose" aria-hidden="true" data-id="element-71" data-mp="1d85lnxutkh59" />
                  <span className="text-sm leading-relaxed text-cream-muted sm:text-base" data-id="element-72" data-mp="189atw6evji90">{row.without}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-8" data-id="element-73" data-mp="24xh2t5itwwt3">
            <p className="text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-74" data-mp="20yrguojq66xu">Z Arsenałem</p>
            <ul className="mt-5 divide-y divide-night-600" data-id="element-75" data-mp="1vx267a0ezvaa">
              {comparisonRows.map(row => <li key={row.with} className="flex items-start gap-3 py-4 first:pt-0 last:pb-0" data-id="element-76" data-mp="1r1wiq6rd68k3">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber" aria-hidden="true" data-id="element-77" data-mp="khn9m7c4b5fp" />
                  <span className="text-sm font-medium leading-relaxed text-cream sm:text-base" data-id="element-78" data-mp="fmq0z1ir2y3c">{row.with}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}